import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    api_key: "",
    filter_from_date: moment()
      .startOf("month")
      .format("YYYY-MM-DD"),
    filter_to_date: moment()
      .endOf("month")
      .format("YYYY-MM-DD"),
    filter_shop_id: "",
    user_name: "",
    shops: [],
    current_user: {}
  },
  mutations: {
    set_api_key(state, val) {
      state.api_key = val;
    },
    set_user_name(state, val) {
      state.user_name = val;
    },
    set_shops(state, val) {
      state.shops = val;
    },
    set_current_user(state, val) {
      state.current_user = val;
    },
    set_filter_from_date(state, val) {
      state.filter_from_date = val;
    },
    set_filter_to_date(state, val) {
      state.filter_to_date = val;
    },
    set_filter_shop_id(state, val) {
      state.filter_shop_id = val;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store.js